export default __webpack_public_path__ + "static/media/image1281.31af8f3f.png";